'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagZwAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 2.66667H28V0H0V2.66667Z",
          fill: "#369D0C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V17.3333H0V20Z",
          fill: "#369D0C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 8H28V5.33333H0V8Z",
          fill: "#369D0C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 14.6667H28V12H0V14.6667Z",
          fill: "#369D0C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 12H28V8H0V12Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 5.33333H28V2.66667H0V5.33333Z",
          fill: "#FFD40E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 17.3333H28V14.6667H0V17.3333Z",
          fill: "#FFD40E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20V0L13.3333 10L0 20Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 18.3333L11.1111 10L0 1.66667V18.3333ZM13.3333 10L0 20V0L13.3333 10Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 11.3L2.04072 12.6967L2.76363 10.4017L0.829812 8.96994L3.23588 8.94828L4 6.66667L4.76412 8.94828L7.17019 8.96994L5.23637 10.4017L5.95928 12.6967L4 11.3Z",
          fill: "#F12F1F"
        }
      )
    ]
  }
);
const VpFlagZwAsset = forwardRef(FlagZwAsset);

export { VpFlagZwAsset as default };
